import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-597758d7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "rda-summary card"
};
const _hoisted_2 = {
    key: 0,
    class: "rda-summary__container"
};
const _hoisted_3 = { class: "rda-summary__item" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", null, "Total de registros da tabela", -1));
const _hoisted_5 = { class: "rda-summary__item" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", null, "Total de registros com esse filtro", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_loader = _resolveComponent("base-loader");
    return (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.getSummaryLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("p", null, _toDisplayString(_ctx.getSummaryInfos.totalTable), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("p", null, _toDisplayString(_ctx.getSummaryInfos.totalCount) + " (" + _toDisplayString(_ctx.getPercet) + ")", 1)
                    ])
                ]))
                : _createCommentVNode("", true),
            (_ctx.getSummaryLoading)
                ? (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                : _createCommentVNode("", true)
        ]))
        : _createCommentVNode("", true);
}
